/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { Fragment, startTransition } from "react"
import { Menu, Transition } from "@headlessui/react"
import cx from "clsx"
import { Link } from "gatsby"
import DesignerNameSquare from "components/Header/DesignerNameSquare"
import { BurgerMenuIcon } from "components/Icons"
import Logo from "components/Logo"
import useDesignerUser from "hooks/useDesignerUser"
import useMobile from "hooks/useMobile"

export interface HeaderProps {
  setSidebarOpen: (open: boolean) => void
}

const Header = ({ setSidebarOpen }: HeaderProps) => {
  const isMobile: boolean = useMobile()
  const { designerUser } = useDesignerUser()

  const userNavigation = [
    { name: `Edit Profile`, href: `/dashboard/designer/account/` },
    { name: `Accounts`, href: `/dashboard/designer/account/` },
    { name: `Log Out`, href: `/accounts/sign-out/?next=/dashboard-beta/` }
  ]

  return (
    <header className="sticky top-0 z-20 shrink-0 flex h-[3.25rem] bg-white border-b border-primary-mid-gray px-5 py-2.5 md:px-6 md:py-3 md:h-[3.75rem]">
      <div className="flex flex-1 justify-between">
        <Link to="/">
          <Logo className="w-20 md:w-[5.78rem]" />
        </Link>

        <div className="flex items-center">
          <span className="px-2 py-0.5 bg-violet-50 border outline-offset-2 border-violet-400 text-violet-500 font-sans font-medium text-sm rounded uppercase">
            Beta experience
          </span>

          {/* Profile dropdown */}
          <Menu as="div" className="hidden relative ml-4 -mb-1 md:block">
            <Menu.Button>
              {designerUser?.isStaff && !isMobile && (
                <DesignerNameSquare user={designerUser} />
              )}
            </Menu.Button>

            <Transition
              // @ts-ignore
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="origin-top-right absolute right-0 mt-1 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5">
                {userNavigation.map(item => (
                  <Menu.Item key={item.name}>
                    {({ active }) => (
                      <a
                        href={item.href}
                        className={cx(
                          `block px-4 py-2 font-sans text-sm text-gray-700`,
                          { "bg-gray-100": active }
                        )}
                      >
                        {item.name}
                      </a>
                    )}
                  </Menu.Item>
                ))}
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      </div>

      <button
        type="button"
        className="px-3 h-11 -mt-1.5 -mr-3 ml-2 text-gray-500 md:hidden"
        onClick={() =>
          startTransition(() => {
            setSidebarOpen(true)
          })
        }
      >
        <span className="sr-only">Open sidebar</span>
        <BurgerMenuIcon className="w-5" />
      </button>
    </header>
  )
}

export default Header
